export default __webpack_public_path__ + "static/media/shoe.0d424e9b.png";